import React from "react";

// Lib
import { shallowEqual } from "react-redux";
import { useAppSelector, useAppDispatch } from "lib/hooks/useDispatch";

// components
import EmptyDetails from "./EmptyDetails";
import TargetDetails from "./TargetDetails";
import Loader from "components/UiKit/Loader";
import Button from "components/UiKit/Button";

// Actions
import * as actionsCreator from "pages/Thesaurus/reducer";

// Classnames
import clsx from "clsx";

// Interfaces
interface ITargetDetailsContainer {
  className?: string;
};

export const TargetDetailsContainer: React.FC<ITargetDetailsContainer> = (props) => {
  const { className } = props;

  const dispatch = useAppDispatch();

  const thesaurus = useAppSelector(
    (store) => store.thesaurus,
    shallowEqual
  );

  const data = thesaurus.dataTargetDetails;
  const loading = thesaurus.loadingTargetDetails;

  const handleChangeToggleFilter = () => {
    dispatch(actionsCreator.toggleTargetDetails());
  }

  const cnWrapper = clsx(
    "target-details flex flex-ai-center flex-jc-center flex-direction-column relative mt30",
    className ? className : ""
  );

  return (<div className={cnWrapper}>
    <Button
      isSvg
      title="Filter"
      variable="icon"
      icon="crossSvg"
      onPress={handleChangeToggleFilter}
      className="target-details__header-select-icon display-block-mobile"
    />
    {loading
      ? <div className="thesaurus__loader relative mt30 mb30">
        <Loader
          color="dark"
          type="circle"
        />
      </div>
      : Object.values(data)?.length
        ? <TargetDetails data={data} />
        : <EmptyDetails />}
  </div>);
};


export default TargetDetailsContainer;